import { icons } from "@patient-watch/icons";
import { commonComponents as cc } from "@/components/common";
import { ui } from "@patient-watch/ui";
import {
    diaryFootPhotosCameraPath,
    diaryFootPhotosUploadMessagePath,
    diaryNewTrackerEntryPagePath,
} from "@/features/diaries/routes";
import { useImagesStore } from "@/features/foot-watch/hooks/useImagesStore";
import { photoElements as pe } from "@/features/foot-watch/photos";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const Review = () => {
    const { diaryId, trackerId, entryId, pageIndex } = Route.useParams();
    const navigate = useNavigate();
    const images = useImagesStore((s) => s.images);
    const resetVariant = useImagesStore((s) => s.resetVariant);
    const getFirstMissingImage = useImagesStore((s) => s.getFirstMissingImage);

    const routeParams = { diaryId, trackerId, entryId, pageIndex };
    const missingImage = getFirstMissingImage(images);

    const resetAll = () => {
        resetVariant(images, "LT");
        resetVariant(images, "LS");
        resetVariant(images, "RT");
        resetVariant(images, "RS");
    };

    function navigateCamera(side: "left" | "right", angle: "sole" | "top") {
        void navigate({
            to: diaryFootPhotosCameraPath,
            params: routeParams,
            search: {
                side,
                angle,
                delay: angle === "sole" ? 10 : 0,
            },
        });
    }

    return (
        <>
            <p className="mb-6 w-full font-medium text-xl text-center">
                Please check the photos show your whole foot in focus before continuing.
            </p>
            {missingImage !== null && (
                <button
                    type="button"
                    onClick={() => navigateCamera(missingImage.side, missingImage.angle)}
                    className="inline-block bg-red-100 mb-4 px-2 py-2 border-2 border-red-600 rounded-xl w-full text-red-950 text-lg text-left"
                >
                    Incomplete image set, please{" "}
                    <span className="inline text-red-600 underline underline-offset-2">click here</span> to add the
                    missing photos.
                </button>
            )}
            <pe.ImageGallery
                imageTL={images.LT.base64}
                imageTR={images.RT.base64}
                imageBL={images.LS.base64}
                imageBR={images.RS.base64}
                linkTR={() => navigateCamera("right", "top")}
                linkTL={() => navigateCamera("left", "top")}
                linkBR={() => navigateCamera("right", "sole")}
                linkBL={() => navigateCamera("left", "sole")}
            />
            <ui.Button
                variant="ghost"
                onClick={() => {
                    resetAll();
                    void navigate({ to: diaryNewTrackerEntryPagePath, params: routeParams });
                }}
            >
                Cancel Check-in
            </ui.Button>
            <cc.FooterButtons
                func1={() =>
                    void navigate({
                        to: diaryFootPhotosUploadMessagePath,
                        params: routeParams,
                    })
                }
                words1="Next"
                disabled1={missingImage !== null}
                icon1={<icons.ForwardArrow />}
            />
        </>
    );
};

export const Route = createFileRoute(
    "/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/"
)({
    component: Review,
});
